<wms-dialog-header title="{{locale[title]}}" (onClose)="closeModal()"></wms-dialog-header>
<wms-dialog-body>
  <wms-message [scopeDataset]="message"></wms-message>
  <span class="app-dialog-body-title">{{dialogMessage}}
    <ul ng-if="!processing && disableOk">
      <li *ngFor="let page of pages"> {{page.trim()}} </li>
    </ul>
  </span>
  <span class="app-dialog-body-caution"><strong>{{locale.LABEL_NOTE | uppercase}}</strong>: {{locale.CAUTION_DELETE_PREFAB_FROM_PROJECT}}</span>
</wms-dialog-body>
<wms-dialog-footer>
  <button class="button-secondary btn app-button" [disabled]="processing" title="{{locale.LABEL_CANCEL}}" (click)="closeModal()"><span class="btn-caption">{{locale.LABEL_CANCEL}}</span></button>
  <button class="button-primary btn app-button" [disabled]="disableOk" title="{{locale.LABEL_PLAN_PROCEED}}" (click)="deletePrefabFromProject()"><span class="btn-caption">{{locale.LABEL_PLAN_PROCEED}}</span></button>
</wms-dialog-footer>
